<template lang="pug">

    div

        //- Navigation
        navigation

        //- Content
        form.ui.form(v-on:submit.prevent="submit()")

            .ui.top.attached.header Benutzerinformation:
            .ui.bottom.attached.segment
                general-information-form(ref="generalInformationForm" v-model="user")

            .ui.top.attached.header Personendaten:
            .ui.bottom.attached.segment
                person-form(ref="personForm" v-bind:company-models="companies" v-model="person" )

            template(v-if="canEditRoles")
                .ui.top.attached.header Rollen:
                .ui.bottom.attached.segment
                    p.ui.error.message {{ validation.firstError('user.roles') }}
                    role-form(ref="roleForm" v-bind:companyModel="companyModel" v-model="user")

            .ui.bottom.secondary
                .ui.column.grid
                    .right.aligned.column
                        a.ui.labeled.icon.button(v-on:click='cancel()')
                            i.remove.icon
                            |  Abbrechen
                        button.ui.labeled.primary.icon.button
                            i.checkmark.icon
                            |  Speichern

</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import store from '@/store'
    import GeneralInformationForm from '@/components/users/GeneralInformationForm.vue'
    import RoleForm from '@/components/users/RoleForm.vue'
    import PersonForm from '@/components/persons/Form.vue'
    import Navigation from '@/components/users/Navigation.vue'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        components: {
            GeneralInformationForm, Navigation, PersonForm, RoleForm
        },

        beforeRouteEnter(to, from, next) {
            // Unternehmen und Personen für Dropdowns laden
            Promise.all([
                store.dispatch('persons/loadAll'),
                store.dispatch('companies/loadAll'),
            ])
                // Benutzer laden
                .then(() => store.dispatch('users/loadOne', { id: to.params.id, force: true }))
                // Person des Benutzers laden (auch System-Firmen, die in loadAll fehlen)
                .then(user => store.dispatch('persons/loadOne', { id: user.person }))
                // Unternehmen der Person laden (auch System-Firma)
                .then(person => store.dispatch('companies/loadOne', { id: person.company }))
                .then(() => next())
        },

        computed: {

            canEditRoles() {
                return (this.$auth.roleIds || []).includes('ADMIN')
            },

            companyModel() {
                return store.getters['companies/byId'](this.person.company) || {}
            },

            companies() {
                return store.getters['companies/all']
            },

        },

        created() {
            this.user = store.getters['users/byId'](this.$route.params.id)
            this.person = store.getters['persons/byId'](this.user.person)
        },

        data() {
            return {
                person: {},
                user: {}
            }
        },

        methods: {
            cancel() {
                this.$router.push({ name: 'users' })
            },

            submit() {
                this.validate().then(() => {
                    Promise.all([
                        store.dispatch('users/update', { model: this.user }),
                        store.dispatch('persons/update', { model: this.person })
                    ])
                        .then(() => this.$growl.success('Benutzer wurde aktualisiert'))
                        .then(() => this.$router.push({ name: 'users' }))
                        .catch(e => this.$growl.fatal('Benutzer konnte nicht gespeichert werden. Bitte den Service kontaktieren.', e))

                }).catch(() => this.$scrollToAndFocus('.field.error'))
            },

            validate() {
                const validators = [
                    this.$refs.generalInformationForm.validate(),
                    this.$refs.personForm.validate(),
                ]

                if (this.canEditRoles) {
                    validators.push(this.$refs.roleForm.validate())
                }

                return Promise.all(validators)
            }

        },

        validators: {

            'user.roles'(roles) {
                return Validator.value(R.defaultTo('', roles))
                    .required('Geben Sie mindesten eine Rolle an.')
            }

        },

    }

</script>
